import { useQuery } from '@tanstack/react-query';
import { ChatFileTypes } from './chatFileTypes';

export function useChatFileTypes() {
  return useQuery<ChatFileTypes>({
    queryKey: ['chat', 'file-types'],
    staleTime: Infinity,
  });
}
